"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("./styled-components");
var _LoadingSpinner = _interopRequireDefault(require("../LoadingSpinner"));
var _excluded = ["error", "loading", "prefix", "suffix", "warning"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Input = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var error = _ref.error,
    loading = _ref.loading,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    warning = _ref.warning,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.InputWrapper, null, prefix ? /*#__PURE__*/_react["default"].createElement(_styledComponents.Prefix, {
    pointerEvents: typeof prefix === 'string' ? 'none' : 'auto'
  }, prefix) : null, /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledInput, _extends({
    warning: warning,
    error: error,
    ref: ref
    // @ts-ignore
    ,
    prefix: prefix
  }, otherProps)), suffix && !loading ? /*#__PURE__*/_react["default"].createElement(_styledComponents.Suffix, {
    pointerEvents: typeof suffix === 'string' ? 'none' : 'auto'
  }, suffix) : null, loading ? /*#__PURE__*/_react["default"].createElement(_styledComponents.LoadingSpinnerWrapper, null, /*#__PURE__*/_react["default"].createElement(_LoadingSpinner["default"], {
    size: 16,
    bg: "primary"
  })) : null);
});
Input.propTypes = {
  error: _propTypes["default"].bool,
  warning: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  prefix: _propTypes["default"].node,
  suffix: _propTypes["default"].node
};
Input.displayName = 'Input';
var _default = exports["default"] = Input;